"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const Text_1 = require("./Text");
const getOnClickAccent = () => (React.createElement("svg", { style: { position: 'absolute', top: 5, right: 5 }, width: "16px", height: "16px", viewBox: "0 0 16 16" },
    React.createElement("g", { id: "Report-/-Scheduled", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "Stats", transform: "translate(-683.000000, -61.000000)", fill: "#D8D8D8" },
            React.createElement("polygon", { id: "Triangle-2", transform: "translate(691.000000, 69.000000) rotate(-180.000000) translate(-691.000000, -69.000000) ", points: "683 61 699 77 683 77" })))));
const getStyle = (style) => (Object.assign({ backgroundColor: colors_1.almostWhite, border: `1px solid ${colors_1.titanium}`, height: 128, padding: '32px 0', textAlign: 'center', width: 224 }, style));
const getValueStyle = (status) => {
    switch (status) {
        case 'good':
            return colors_1.green;
        case 'bad':
            return colors_1.red;
        case 'ok':
            return colors_1.yellow;
        case 'N/A':
            return colors_1.steel;
        default:
            return colors_1.charcoal;
    }
};
const Statistic = ({ label, onClick, status, style, value }) => (React.createElement("div", { onClick: onClick, style: Object.assign({ position: 'relative' }, getStyle(style)) },
    onClick && getOnClickAccent(),
    React.createElement(Text_1.default, { size: "h1", text: value, textStyle: { color: getValueStyle(status), display: 'block' } }),
    React.createElement(Text_1.default, { size: "small", text: label, label: true })));
exports.default = Statistic;
